var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29626 0.599976H13.7031C15.7334 0.599976 17.3999 2.26629 17.3999 4.29663V13.6949C17.3999 15.7335 15.7334 17.4 13.7031 17.4H4.29626C2.26607 17.4 0.599609 15.7335 0.599609 13.6949V4.29663C0.599609 2.26629 2.26607 0.599976 4.29626 0.599976Z",
    fill: "#0A0B09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53692 4.26248C5.28271 4.26248 4.26233 5.28269 4.26233 6.53692V11.4631C4.26233 12.7172 5.28271 13.7377 6.53692 13.7377H11.463C12.7172 13.7377 13.7376 12.7172 13.7376 11.4631V6.53692C13.7376 5.28269 12.7172 4.26248 11.463 4.26248H6.53692ZM11.463 14.7178H6.53692C4.74233 14.7178 3.28223 13.2578 3.28223 11.4631V6.53692C3.28223 4.74231 4.74233 3.28229 6.53692 3.28229H11.463C13.2575 3.28229 14.7177 4.74231 14.7177 6.53692V11.4631C14.7177 13.2578 13.2575 14.7178 11.463 14.7178Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99937 7.05222C7.92527 7.05222 7.05148 7.92595 7.05148 8.99997C7.05148 10.074 7.92527 10.9478 8.99937 10.9478C10.0734 10.9478 10.9472 10.074 10.9472 8.99997C10.9472 7.92595 10.0734 7.05222 8.99937 7.05222ZM8.99937 11.9281C7.38478 11.9281 6.07129 10.6146 6.07129 8.99997C6.07129 7.38551 7.38478 6.07196 8.99937 6.07196C10.6138 6.07196 11.9274 7.38551 11.9274 8.99997C11.9274 10.6146 10.6138 11.9281 8.99937 11.9281Z",
    fill: "#FFFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7571 5.90463C12.7571 6.29324 12.442 6.60825 12.0534 6.60825C11.6647 6.60825 11.3496 6.29324 11.3496 5.90463C11.3496 5.51592 11.6647 5.20068 12.0534 5.20068C12.442 5.20068 12.7571 5.51592 12.7571 5.90463Z",
    fill: "#FFFFFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6ded4458.svg";
export { ForwardRef as ReactComponent };